import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { Box } from './ventblock';
import ekggreen from '../img/ekggreen.png'
import ekgblue from '../img/ekgblue.png'
import lungs from '../img/lungs.png'


export default function StatsImg() {


  return (
    <Grid>
      <ColGrid>
        <ColP>
          <ColY>
            <Img src={ekgblue} />
            <Large>93</Large>
          </ColY>
          <ColYY>
            <Label>Sp02</Label>
            <Label>%</Label>
          </ColYY>
        </ColP>
        <Col>
          <BLabel>Male</BLabel>
          <Label>174cm</Label>
          <Label>-</Label>
        </Col>
        <Col>
          <BLabel>10</BLabel>
          <Label>Rinsp</Label>
          <Label>cmH20/1/s</Label>
        </Col>
      </ColGrid>
      <MiniGrid>
        <ColP>
          <ColY>
            <Img src={ekggreen} />
            <Large>90</Large>
          </ColY>
          <ColYY>
            <Label>Pulse</Label>
            <Label>1/min</Label>
          </ColYY>
        </ColP>
        <Col>
          <BLabel>36.2</BLabel>
          <Label>Cstat</Label>
          <Label>ml/cmH20</Label>
        </Col>
        <Col>
          <BLabel>43</BLabel>
          <Label>PetC02</Label>
          <Label>mmHG</Label>
        </Col>
      </MiniGrid>
      <LWrap>
        <Lungs src={lungs} />
      </LWrap>
    </Grid>
  )
}

const LWrap = styled.div`
  position: relative;
`;

const Lungs = styled.img`
position: absolute;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
const Img = styled.img`
  width: 50%;
    @media screen and (max-width: 823px) and (orientation: landscape) {
    width: 80%;
    }
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 3fr;
  grid-gap: 10px;
  @media screen and (max-width: 823px) and (orientation: landscape) {
      overflow: hidden;
        grid-template-columns: 1fr 1fr 2fr;
        grid-gap: 5px;

    }
`;

const MiniGrid = styled.div`
display: grid;
grid-template-rows: 2fr 1fr;
grid-gap: 10px;
  @media screen and (max-width: 823px) and (orientation: landscape) {
    grid-gap: 5px;
    overflow: hidden;
    }
`;

const ColGrid = styled(MiniGrid)`
padding-left: 20px;
  @media screen and (max-width: 823px) and (orientation: landscape) {
    padding-left: 5px;
    }
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
`;

const ColY = styled(Col)`
    width: 40px;
`;
const ColYY = styled(Col)`
      @media screen and (max-width: 823px) and (orientation: landscape) {
     align-self: flex-end;
    }
    
`;

const ColP = styled(Col)`
  align-self: center;
    @media screen and (max-width: 823px) and (orientation: landscape) {
   flex-direction: row;
    }
`;

const Large = styled.div`
  font-size: 40px;
  font-weight: 600;
    @media screen and (max-width: 823px) and (orientation: landscape) {
    font-size: 20px;
    }
`;

const Label = styled.div`
color: rgba(255,255,255,0.5);
font-size: 14px;
  @media screen and (max-width: 823px) and (orientation: landscape) {
   font-size: 12px;
    }
`;

const BLabel = styled.div`

`;